<template>
  <div class="content">
    <div class="search-container">
      <searchBox @submit="handleSubmit" :default="1" />
    </div>
    <div class="hot-search-box" v-if="hotSearchList.length > 0">
      <div class="tab-container clearfix">
        <div class="tab-item active">热词搜索</div>
        <!-- <div class="tab-item">资料</div>
        <div class="tab-item">专辑</div>
        <div class="tab-item">套卷</div> -->
        <div
          class="change-oper"
          data-io-click="tracker"  @click="changePageIndex"
          v-if="hotSearchList.length > 10"
        >
          <i class="iconfont icon-change"></i>换一批
        </div>
      </div>
      <div class="tab-card-container">
        <ul class="left" :class="{ 'first-page': pageIndex === 1 }">
          <li
            v-for="(item, index) in showSearchList.slice(0, 5)"
            :key="index"
            data-io-click="tracker"  @click="handleJumpSearchList(item)"
          >
            <span>{{ (pageIndex - 1) * 10 + index + 1 }}</span>
            {{ item }}
          </li>
        </ul>
        <ul class="right">
          <li
            v-for="(item, index) in showSearchList.slice(5, 10)"
            :key="index"
            data-io-click="tracker"  @click="handleJumpSearchList(item)"
          >
            <span>{{ (pageIndex - 1) * 10 + index + 1 + 5 }}</span>
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import searchBox from "@/components/searchBox";
import request from "@/utils/request";
import Cookie from "js-cookie";
import api from "@/assets/js/service/api";
import { mapState } from "vuex";
const SEARCHHISTORY = "SEARCHHISTORY";
export default {
  components: {
    searchBox,
  },
  data() {
    return {
      showHistoryBox: false,
      hotSearchList: [],
      // 当前页数
      pageIndex: 1,
      totalPage: 1,
    };
  },
  computed: {
    ...mapState(["currentCourse"]),
    showSearchList() {
      return this.hotSearchList.slice(
        (this.pageIndex - 1) * 10,
        this.pageIndex * 10
      );
    },
  },
  watch: {
    currentCourse: {
      handler(val) {
        if (val) {
          this.getHotSearchList();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // this.getHotSearchList();
  },
  methods: {
    addSearchHistory(keyword) {
      let searchHistory = Cookie.get(SEARCHHISTORY) || [];
      if (searchHistory.length > 0) {
        searchHistory = JSON.parse(decodeURIComponent(searchHistory));
      }
      let findIndex = searchHistory.findIndex((item) => {
        return keyword == item;
      });
      if (findIndex == -1) {
        searchHistory.push(keyword);
        Cookie.set(SEARCHHISTORY, JSON.stringify(searchHistory));
      }
    },
    handleJumpSearchList(item) {
      this.addSearchHistory(item);
      this.$router.push(
        `/search/result/?title=${item}&pageSize=30&pageIndex=1`
      );
    },
    getHotSearchList() {
      let { stageId, subjectId } = this.currentCourse;
      request
        .postJson(api.search.hotSearchSite, {
          size: 10,
          stageId,
          subjectId,
        })
        .then((hotSearchList) => {
          hotSearchList.result = hotSearchList.result.slice(0, 30);
          this.totalPage = Math.ceil(hotSearchList.result.length / 10);
          this.hotSearchList = hotSearchList.result;
        });
    },
    changePageIndex() {
      let currentPageIndex = this.pageIndex;
      this.pageIndex =
        currentPageIndex >= this.totalPage ? 1 : currentPageIndex + 1;
    },
    handleSubmit(e) {
      let { stageId, subjectId } = this.currentCourse;
      this.$router.push(
        `/search/result/?title=${e.keyword}&pageSize=30&pageIndex=1&stageId=${stageId}&subjectId=${subjectId}`
      );
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  width: 100%;
  height: 100%;
  background: url("~@/assets/images/search-bg.png") center top no-repeat #fff;
  background-size: 1920px 511px;
  overflow: hidden;

  .search-container {
    margin: 0 auto;
    width: 656px;
    margin-top: 170px;
  }

  .hot-search-box {
    margin: 0 auto;
    width: 642px;
    margin-top: 50px;

    .tab-card-container {
      overflow: hidden;

      ul {
        width: 50%;

        li {
          position: relative;
          cursor: pointer;
          width: 100%;
          margin-top: 20px;
          padding-left: 27px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 14px;
          line-height: 14px;
          color: #333;

          span {
            position: absolute;
            left: 0;
            top: 0;
            color: #80848b;
            font-weight: 500;
          }
        }

        &:nth-of-type(1) {
          &.first-page {
            li {
              &:first-child {
                // margin-top: 26px;
                span {
                  color: #fe2d46;
                }
              }

              &:nth-of-type(2) {
                span {
                  color: #ff6b00;
                }
              }

              &:nth-of-type(3) {
                span {
                  color: #faa90e;
                }
              }
            }
          }
        }

        &.right {
          li {
            text-indent: 2em;
          }
        }
      }
    }
  }
}
</style>
